import { css, polished } from 'jimu-core';
export const inputGroupStyles = (props) => {
    var _a, _b, _c;
    const size = props.size;
    const theme = props.theme;
    const inputVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.input;
    const inputGroupVars = (_b = theme === null || theme === void 0 ? void 0 : theme.components) === null || _b === void 0 ? void 0 : _b.inputGroup;
    return inputVars && inputGroupVars && css `
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;

    > .jimu-input {
      position: relative;
      flex: 1 1 auto;
      width: 1%;
      margin-bottom: 0;

      + .jimu-input {
        margin-left: -${inputVars.border.width};
      }
    }

    > .jimu-input:focus {
      z-index: 3;
    }

    > .jimu-input {
      &:not(:last-child) {
        &,
        .jimu-numeric-input-input {
          ${polished.borderRadius('right', '0')};
        }
      }
      &:not(:first-of-type) {
        &,
        .jimu-numeric-input-input {
          ${polished.borderRadius('left', '0')};
        }
      }
    }

    > .jimu-btn {
      &:disabled {
        // use the same colors from Input for the disabled state
        background: ${inputVars === null || inputVars === void 0 ? void 0 : inputVars.bg};
        border-color: ${(_c = inputVars === null || inputVars === void 0 ? void 0 : inputVars.border) === null || _c === void 0 ? void 0 : _c.color};
      }
    }

    .input-group-prepend,
    .input-group-append {
      display: flex;

      .btn {
        position: relative;
        z-index: 2;
      }

      .btn + .btn,
      .btn + .input-group-text,
      .input-group-text + .input-group-text,
      .input-group-text + .btn {
        margin-left: -${inputVars.border.width};
      }
    }

    .input-group-text {
      display: flex;
      align-items: center;
      padding: ${inputVars.sizes.default.paddingY} ${inputVars.sizes.default.paddingX};
      margin-bottom: 0;
      font-size: ${theme.sys.typography.body1.fontSize};
      font-weight: ${theme.ref.typeface.fontWeightRegular};
      line-height: ${inputVars.sizes.default.lineHeight};
      color: ${inputGroupVars.addon.color};
      text-align: center;
      white-space: nowrap;
      background-color: ${inputGroupVars.addon.bg};
      border: ${inputVars.border.width} solid ${inputGroupVars.addon.borderColor};
      border-radius: ${inputVars.sizes.default.borderRadius};

      input[type="radio"],
      input[type="checkbox"] {
        margin-top: 0;
      }
    }

    /* Sizing */

    ${size === 'lg' && css `
      > .jimu-input,
      > .input-group-prepend > .input-group-text,
      > .input-group-append > .input-group-text,
      > .input-group-prepend > .btn,
      > .input-group-append > .btn {
        height: ${inputVars.sizes.lg.height};
        padding: ${inputVars.sizes.lg.paddingY} ${inputVars.sizes.lg.paddingX};
        font-size: ${inputVars.sizes.lg.fontSize};
        line-height: ${inputVars.sizes.lg.height};
        border-radius: ${inputVars.sizes.lg.borderRadius};
      }
    `}

    ${size === 'sm' && css `
      > .jimu-input,
      > .input-group-prepend > .input-group-text,
      > .input-group-append > .input-group-text,
      > .input-group-prepend > .btn,
      > .input-group-append > .btn {
        height: ${inputVars.sizes.sm.height};
        padding: ${inputVars.sizes.sm.paddingY} ${inputVars.sizes.sm.paddingX};
        font-size: ${inputVars.sizes.sm.fontSize};
        line-height: ${inputVars.sizes.sm.height};
        border-radius: ${inputVars.sizes.sm.borderRadius};
      }
    `}

    .input-group-prepend > .btn,
    .input-group-prepend > .input-group-text,
    .input-group-append:not(:last-child) > .btn,
    .input-group-append:not(:last-child) > .input-group-text,
    .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
    .input-group-append:last-child > .input-group-text:not(:last-child) {
      ${polished.borderRadius('right', '0')};
    }
    &.input-group-append > .btn,
    .input-group-append > .input-group-text,
    .input-group-prepend:not(:first-of-type) > .btn,
    .input-group-prepend:not(:first-of-type) > .input-group-text,
    .input-group-prepend:first-of-type > .btn:not(:first-of-type),
    .input-group-prepend:first-of-type > .input-group-text:not(:first-of-type)
    {
      ${polished.borderRadius('left', '0')};
    }
  `;
};
